var _style, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _g4, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 40.3",
    style: {
      enableBackground: "new 0 0 135 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{opacity:0.2;enable-background:new    ;}\n\t.st8{opacity:0.12;enable-background:new    ;}\n\t.st9{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130,40.1H5c-2.8,0-5-2.2-5-5v-30c0-2.7,2.2-5,5-5h125c2.8,0,5,2.2,5,5v30C135,37.9,132.8,40.1,130,40.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130,0.9c2.3,0,4.2,1.9,4.2,4.2v30c0,2.3-1.9,4.2-4.2,4.2H5c-2.3,0-4.2-1.9-4.2-4.2v-30 c0-2.3,1.9-4.2,4.2-4.2H130 M130,0.1H5c-2.8,0-5,2.2-5,5v30c0,2.8,2.2,5,5,5h125c2.8,0,5-2.2,5-5v-30C135,2.4,132.8,0.1,130,0.1 L130,0.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,10.4c0,0.8-0.2,1.5-0.7,2c-0.6,0.6-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2 c0-0.9,0.3-1.6,0.9-2.2C42.9,7.3,43.6,7,44.5,7c0.4,0,0.8,0.1,1.2,0.3c0.4,0.2,0.7,0.4,0.9,0.7l-0.5,0.5c-0.4-0.5-0.9-0.7-1.6-0.7 c-0.6,0-1.2,0.2-1.6,0.7c-0.5,0.4-0.7,1-0.7,1.7s0.2,1.3,0.7,1.7c0.5,0.4,1,0.7,1.6,0.7c0.7,0,1.2-0.2,1.7-0.7 c0.3-0.3,0.5-0.7,0.5-1.2h-2.2V9.9h2.9C47.4,10.1,47.4,10.2,47.4,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,7.8h-2.7v1.9h2.5v0.7h-2.5v1.9H52v0.7h-3.5v-6H52V7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,13.1h-0.8V7.8h-1.7V7.1H57v0.7h-1.7V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.9,13.1v-6h0.8v6H59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,13.1h-0.8V7.8h-1.7V7.1h4.1v0.7h-1.7V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,12.3c-0.6,0.6-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2s0.3-1.6,0.9-2.2 C69.8,7.3,70.5,7,71.4,7c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.9,1.3,0.9,2.2C74.5,11,74.2,11.7,73.6,12.3z M69.8,11.8 c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.7S73.5,8.8,73,8.4c-0.4-0.4-1-0.7-1.6-0.7 c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.7S69.3,11.4,69.8,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,13.1v-6h0.9l2.9,4.7h0l0-1.2V7.1h0.8v6h-0.8l-3.1-4.9h0l0,1.2v3.7H75.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.1,21.9c-2.4,0-4.3,1.8-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.8,4.3-4.3C72.4,23.7,70.5,21.9,68.1,21.9 z M68.1,28.7c-1.3,0-2.4-1.1-2.4-2.6c0-1.5,1.1-2.6,2.4-2.6c1.3,0,2.4,1,2.4,2.6C70.5,27.6,69.4,28.7,68.1,28.7z M58.8,21.9 c-2.4,0-4.3,1.8-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.8,4.3-4.3C63.1,23.7,61.2,21.9,58.8,21.9z M58.8,28.7 c-1.3,0-2.4-1.1-2.4-2.6c0-1.5,1.1-2.6,2.4-2.6c1.3,0,2.4,1,2.4,2.6C61.2,27.6,60.1,28.7,58.8,28.7z M47.7,23.2V25h4.3 c-0.1,1-0.5,1.8-1,2.3c-0.6,0.6-1.6,1.3-3.3,1.3c-2.7,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8c1.4,0,2.5,0.6,3.3,1.3l1.3-1.3 c-1.1-1-2.5-1.8-4.5-1.8c-3.6,0-6.7,3-6.7,6.6c0,3.6,3.1,6.6,6.7,6.6c2,0,3.4-0.6,4.6-1.9c1.2-1.2,1.6-2.9,1.6-4.2 c0-0.4,0-0.8-0.1-1.1H47.7z M93.1,24.6c-0.4-1-1.4-2.7-3.6-2.7c-2.2,0-4,1.7-4,4.3c0,2.4,1.8,4.3,4.2,4.3c1.9,0,3.1-1.2,3.5-1.9 l-1.4-1c-0.5,0.7-1.1,1.2-2.1,1.2c-1,0-1.6-0.4-2.1-1.3l5.7-2.4L93.1,24.6z M87.3,26c0-1.6,1.3-2.5,2.2-2.5c0.7,0,1.4,0.4,1.6,0.9 L87.3,26z M82.6,30.1h1.9V17.6h-1.9V30.1z M79.6,22.8L79.6,22.8c-0.5-0.5-1.3-1-2.3-1c-2.1,0-4.1,1.9-4.1,4.3c0,2.4,1.9,4.2,4.1,4.2 c1,0,1.8-0.5,2.2-1h0.1V30c0,1.6-0.9,2.5-2.3,2.5c-1.1,0-1.9-0.8-2.1-1.5l-1.6,0.7c0.5,1.1,1.7,2.5,3.8,2.5c2.2,0,4-1.3,4-4.4v-7.6 h-1.8V22.8z M77.4,28.7c-1.3,0-2.4-1.1-2.4-2.6c0-1.5,1.1-2.6,2.4-2.6c1.3,0,2.3,1.1,2.3,2.6C79.7,27.6,78.7,28.7,77.4,28.7z  M101.8,17.6h-4.5v12.5h1.9v-4.7h2.6c2.1,0,4.1-1.5,4.1-3.9S103.9,17.6,101.8,17.6z M101.9,23.6h-2.7v-4.3h2.7 c1.4,0,2.2,1.2,2.2,2.1C104,22.5,103.2,23.6,101.9,23.6z M113.4,21.8c-1.4,0-2.8,0.6-3.3,1.9l1.7,0.7c0.4-0.7,1-0.9,1.7-0.9 c1,0,1.9,0.6,2,1.6v0.1c-0.3-0.2-1.1-0.5-1.9-0.5c-1.8,0-3.6,1-3.6,2.8c0,1.7,1.5,2.8,3.1,2.8c1.3,0,1.9-0.6,2.4-1.2h0.1v1h1.8v-4.8 C117.2,23.1,115.5,21.8,113.4,21.8z M113.2,28.7c-0.6,0-1.5-0.3-1.5-1.1c0-1,1.1-1.3,2-1.3c0.8,0,1.2,0.2,1.7,0.4 C115.2,27.9,114.2,28.7,113.2,28.7z M123.7,22.1l-2.1,5.4h-0.1l-2.2-5.4h-2l3.3,7.6l-1.9,4.2h1.9l5.1-11.8H123.7z M106.9,30.1h1.9 V17.6h-1.9V30.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7996,
    y1: 193.178,
    x2: 5.0172,
    y2: 176.3956,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,7.7C10.1,8,10,8.4,10,9.1v22.1c0,0.6,0.2,1.1,0.5,1.4l0.1,0.1l12.4-12.4v-0.1V20L10.4,7.7L10.4,7.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8343,
    y1: 181.8862,
    x2: 9.6374,
    y2: 181.8862,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27,24.4l-4.1-4.1v-0.1V20l4.1-4.1l0.1,0.1l4.9,2.8c1.4,0.8,1.4,2.1,0,2.9L27,24.4L27,24.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8269,
    y1: 179.5916,
    x2: 2.0686,
    y2: 156.8333,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.1,24.3l-4.2-4.2L10.4,32.6c0.5,0.5,1.2,0.5,2.1,0.1L27.1,24.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2972,
    y1: 201.7115,
    x2: 17.4598,
    y2: 191.549,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.1,15.9L12.5,7.6c-0.9-0.5-1.6-0.4-2.1,0.1l12.5,12.5L27.1,15.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27,24.2l-14.5,8.2c-0.8,0.5-1.5,0.4-2,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.5,0.4,1.2,0.5,2,0L27,24.2L27,24.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.4,32.4C10.1,32.1,10,31.6,10,31v0.1c0,0.6,0.2,1.1,0.5,1.4V32.4L10.4,32.4z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32,21.4l-5,2.8l0.1,0.1l4.9-2.8c0.7-0.4,1-0.9,1-1.4l0,0C33,20.6,32.6,21.1,32,21.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.5,7.7L32,18.8c0.6,0.4,1,0.8,1,1.3l0,0c0-0.5-0.3-1-1-1.4L12.5,7.6C11.1,6.8,10,7.5,10,9.1v0.1 C10,7.6,11.1,6.9,12.5,7.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.ca200afd6278196f478115c5bbfe9c7a.svg";
export { ForwardRef as ReactComponent };